






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedLoading } from "../../../../../system";
import { FixedPhraseRootReference } from "../../../../../../domain/document";
import FixedPhraseTreeSelector from "../../../../../document/fixedPhrase/FixedPhraseTreeSelector.vue";
import { FixedPhraseKinds } from "../../../../../document/fixedPhrase/FixedPhraseKinds";
import { FixedPhraseTreeSelectorMixin } from "../../../../../document/fixedPhrase/mixins";
import { FixedPhraseTreeViewerMixin } from "../mixins";
import { IEditFixedPhrase } from "../../../../../document/fixedPhrase/IEditFixedPhrase";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class ReceptionDepartmentFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
  FixedPhraseTreeViewerMixin,
) implements IEditFixedPhrase {
  @Prop()
  departmentId: string;

  async created(): Promise<void> {
    await this.loadDirectories();
  }

  private async loadDirectories(): Promise<void> {
    if (this.departmentId === null) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      return;
    }
    try {
      this.rootFixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.ReceptionDepartment, this.departmentId);
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "主" + this.$wording.common.departmentAsShort + "定型文取得失敗",
        "主" + this.$wording.common.departmentAsShort + "定型文を読み込めませんでした。",
        e);
    }
  }

  mounted(): void {
    this.selector = this.$refs.selector;
    window.addEventListener("message", this.onWindowNotify, false);
  }

  destroyed(): void {
    window.removeEventListener("message", this.onWindowNotify, false);
  }

  private onWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data);
      if (message.key === "departmentFixedPhraseUpdated") {
        this.loadDirectories();
      }
    } catch {}
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.ReceptionDepartment, isForcibly, this.departmentId), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.ReceptionDepartment, this.departmentId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.ReceptionDepartment, this.departmentId);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.ReceptionDepartment, result, () => this.notifyMessage("departmentFixedPhraseUpdated"));
  }
}
